import { actions } from './constants.js';

const openDrawer = () => ({
  type: actions.drawer.opened
});
const closeDrawer = () => ({
  type: actions.drawer.closed
});
const setValue = (field, value) => ({
  type: actions.filters.setValue,
  payload: {
    field,
    value
  }
});
const saveFilters = () => ({
  type: actions.filters.save
});
const saveOneFilter = field => ({
  type: actions.filters.save,
  payload: {
    field
  }
});
const dismissFilters = () => ({
  type: actions.filters.dismiss
});
const removeValue = (field, value) => ({
  type: actions.filters.removeValue,
  payload: {
    field,
    value
  }
});
const clearAll = () => ({
  type: actions.filters.clearAll
});
const setFilters = filters => ({
  type: actions.filters.setFilters,
  payload: {
    value: filters
  }
});

export { clearAll, closeDrawer, dismissFilters, openDrawer, removeValue, saveFilters, saveOneFilter, setFilters, setValue };
